import { useIntl } from 'react-intl';
import { EBetState } from '../../../../api/punter/punter.types';

export const useTabs = () => {
  const intl = useIntl();

  return [
    {
      value: [EBetState.Pending],
      display: intl.formatMessage({
        id: `account.mybets.pendingview`,
      }),
    },
    {
      value: [
        EBetState.Settled,
        EBetState.Voided,
        EBetState.Cancelled,
        EBetState.CashedOut,
      ],
      display: intl.formatMessage({
        id: `account.mybets.resultedview`,
      }),
    },
  ];
};
